import { LayoutWithNavigationBar } from "../../layouts/layout-with-navigation-bar";
import { MainView } from "../../views/home";

export default function HomePage(props) {
    return (
        <>
            <LayoutWithNavigationBar>
                <MainView />
            </LayoutWithNavigationBar>
        </>
    );
}